import { render } from "./MetadataModal.vue?vue&type=template&id=69050f7c&ts=true"
import script from "./MetadataModal.vue?vue&type=script&lang=ts"
export * from "./MetadataModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__